var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { css, cx } from '@emotion/css';
import { theme } from '../../theme';
const baseButtonStyles = css({
    boxSizing: 'border-box',
    margin: 0,
    appearance: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '24px',
    textDecoration: 'none',
    letterSpacing: '1.25px',
    borderRadius: '24px',
    position: 'relative',
    pointerEvents: 'auto',
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: '8px',
    paddingBottom: '8px',
    minWidth: '120px',
    textTransform: 'uppercase',
    color: theme.colors.white,
    border: `1px solid ${theme.colors.gray500}`,
    backgroundColor: theme.colors.gray500,
    '&:not(:disabled)': {
        cursor: 'pointer',
    },
    transitionProperty: 'border-color, background-color, color',
    transitionDuration: '80ms',
    transitionTimingFunction: 'ease-out',
});
const primaryButtonStyles = css({
    backgroundColor: theme.colors.chocoBlue,
    color: theme.colors.white,
    border: `1px solid ${theme.colors.chocoBlue}`,
    '&:hover:not(:disabled)': {
        border: `1px solid ${theme.colors.midBlue}`,
        backgroundColor: theme.colors.midBlue,
    },
});
const secondaryButtonStyles = css({
    backgroundColor: theme.colors.white,
    color: theme.colors.chocoBlue,
    border: `1px solid ${theme.colors.chocoBlue}`,
    '&:hover:not(:disabled)': {
        color: theme.colors.midBlue,
        border: `1px solid ${theme.colors.midBlue}`,
    },
});
export const Button = (_a) => {
    var { children, variant } = _a, props = __rest(_a, ["children", "variant"]);
    const { disabled } = props;
    return (React.createElement("button", Object.assign({ type: "button", className: cx({
            [baseButtonStyles]: true,
            [primaryButtonStyles]: variant === 'primary' && !disabled,
            [secondaryButtonStyles]: variant === 'secondary' && !disabled,
        }) }, props), children));
};
//# sourceMappingURL=data:application/json;base64,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